import React, { useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';

import { Messages } from 'primereact/messages';

function OrderFail({ detail }) {
  const msgs1 = useRef(null);

  useEffect(() => {
    msgs1.current.show([
      {
        severity: 'error',
        summary: 'Error:',
        detail: detail || 'This order was rejected, please get in contact with us: support@upshow.tv ',
        sticky: true,
      },
    ]);
  }, []);

  return (
    <div className="">
      <Messages ref={msgs1} />
    </div>
  );
}

OrderFail.propTypes = {
  detail: PropTypes.string,
};

OrderFail.defaultProps = {
  detail: null,
};

export default OrderFail;
